import { tv } from "@ui/lib/tv";
import type { ListingFieldCopy } from "./types";

const styles = tv({
  slots: {
    heading:
      "font-extrabold text-2xl text-neutral-900 leading-8 tracking-[-0.24px] lg:text-display-sm lg:leading-[44px] lg:tracking-[-0.36px]",
    helper: "mt-1 font-normal text-lg text-neutral-600 leading-6",
    header: "flex w-full items-start justify-between gap-4",
    fieldWrapper: "mt-6 flex w-full flex-col",
  },
});

export interface EditorSectionProps extends ListingFieldCopy {
  children: React.ReactNode;
  /**
   * Trailing control aligned with the heading — the editor's counterpart to
   * `Wizard.EntitiesStage`'s slot of the same name, used by collection fields
   * for their "add" affordance.
   */
  headerAction?: React.ReactNode;
}

/**
 * The editor's counterpart to `Wizard.Stage`: same copy, left-aligned in the
 * section pane rather than centred in a wizard. Every editor section renders
 * through this so the heading treatment lives in one place — previously each
 * section carried its own copy of these three `tv` slots.
 */
export function EditorSection({ children, headerAction, heading, helper }: EditorSectionProps) {
  const s = styles();

  return (
    <>
      <div className={s.header()}>
        <div>
          <h1 className={s.heading()}>{heading}</h1>
          <p className={s.helper()}>{helper}</p>
        </div>
        {headerAction}
      </div>
      <div className={s.fieldWrapper()}>{children}</div>
    </>
  );
}
